import { Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, LinearProgress, MenuItem, TextField } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { useState } from "react";
import { usePowerSupplySubAsset } from "../stressEntry/stressEntryQueries";


export const NewSubAsset = ({
    open,
    onClose,
    handleChildData
}: any) => {

    const [selectedSubAsset, setSelectedSubAsset] = useState<string[]>([]);
    const [error, setError] = useState<string | null>(null);

    const handleClose = () => {
        setSelectedSubAsset([]);
        onClose();
    };

    const {
        error: errorAssetTypes,
        data: powerSupplySubAsset,
        isLoading: isLoadingPowerSupplySubAsset,
        isError: isErrorAssetTypes,
    } = usePowerSupplySubAsset();






    const menuProps = {
        PaperProps: { style: { maxHeight: 350, width: 300 } },
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        getContentAnchorEl: null,
    };



    const handleSubAssetChange = (e: any) => {
        setSelectedSubAsset(e.target.value);
    };

    if (isLoadingPowerSupplySubAsset) {
        return <LinearProgress />
    }
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Grid container alignItems="center">
                    <Grid item xs>
                        Link New Asset
                    </Grid>
                    <Grid item>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={4}>

                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <TextField
                            id="sub_asset"
                            label="Select sub-assets"
                            select
                            variant="filled"
                            value={selectedSubAsset}
                            onChange={(e) => {
                                handleSubAssetChange(e);
                                setError(null);
                            }}
                            fullWidth
                            error={!!error}
                            helperText={error || ""}
                            SelectProps={{
                                multiple: true,
                                MenuProps: menuProps as any,
                                renderValue: (selected: any) => {
                                    if (!selected.length) return "None";


                                    return selected
                                        .map((id: number) => {
                                            const asset = powerSupplySubAsset.find((item: any) => item.id === id);
                                            return asset ? asset.asset_name : id;
                                        })
                                        .join(", ");
                                },
                            }}
                        >
                            {powerSupplySubAsset.map((item: any) => (
                                <MenuItem key={item.id} value={item.id} disabled={item.in_use && !item.is_calibration}>
                                    <Grid container alignItems="center" spacing={1} >
                                        <Grid item>
                                            <Checkbox checked={selectedSubAsset.includes(item.id)} />
                                        </Grid>

                                        <Grid item>{item.asset_name}</Grid>

                                        {item.is_calibration_days && (
                                            <Grid item>
                                                <Chip
                                                    label={`● Calibration due in ${item.calibration_due_days}`}
                                                    size="small"
                                                    style={{ color: "red", borderColor: "red" }}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid
                            container
                            justifyContent="center"
                            spacing={2}
                            style={{ marginTop: 24 }}
                        >
                            <Grid item>
                                <Button onClick={handleClose} variant="contained" color="secondary">
                                    CANCEL
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        if (selectedSubAsset.length === 0) {
                                            setError("Please select at least one sub-asset.");
                                            return;
                                        }
                                        const selectedNames = selectedSubAsset.map((id) => {
                                            const asset = powerSupplySubAsset.find((item: any) => item.id === id);
                                            return asset ? asset.asset_name : id;
                                        });

                                        handleChildData(selectedSubAsset, selectedNames);
                                        handleClose();
                                    }}
                                >
                                    LINK NEW ASSET
                                </Button>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>

            </DialogActions>
        </Dialog>
    );
};